import { Toolbar } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import classNames from "classnames";
import * as React from "react";

import { TableOptionActions, useEnhancedTableStyles } from ".";
import { PageActionButton, Text } from "../";
interface EnhancedTableToolbarProps {
    color: "default" | "primary" | "secondary";
    numSelected: number;
    onSelectedAction?: (action: string) => void;
    actions?: TableOptionActions[];
    actionComponent?: React.ReactNode;
    toolbarClassName?: string;
    title: string;
    titleVariant: Variant | "srOnly";
}

export const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
    const classes = useEnhancedTableStyles(props);
    const {
        onSelectedAction,
        numSelected,
        color,
        title,
        titleVariant,
        actions,
        toolbarClassName,
        actionComponent,
    } = props;

    const handleSelectedAction = (action: string) => {
        if (onSelectedAction) {
            onSelectedAction(action);
        }
    };

    return (
        <Toolbar
            className={classNames(classes.tableToolBarRoot, toolbarClassName, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div
                className={classNames(classes.title, {
                    [classes.selectedTitle]: numSelected > 0,
                })}
            >
                {numSelected > 0 ? (
                    <Text dataCy="numSelected" variant="h5" color={color}>
                        {numSelected} selected
                    </Text>
                ) : (
                    <Text variant={titleVariant} id="tableTitle">
                        {title}
                    </Text>
                )}
            </div>
            <div className={classes.actions}>
                {!!actionComponent && actionComponent}
                {numSelected > 0 ? (
                    <>
                        {actions &&
                            actions.map((action, i) => {
                                const {
                                    actionIcon,
                                    actionName,
                                    actionText,
                                    tooltip,
                                } = action;
                                return (
                                    <PageActionButton
                                        key={`${i}-actionName`}
                                        title={tooltip}
                                        color={color}
                                        aria-label={tooltip}
                                        onClick={() =>
                                            handleSelectedAction(actionName)
                                        }
                                    >
                                        {!!actionIcon && actionIcon}
                                        {!!actionText && actionText}
                                    </PageActionButton>
                                );
                            })}
                    </>
                ) : null}
            </div>
        </Toolbar>
    );
};
